import { css } from 'styled-components';

export const sizes = {
    desktop: 1201,
    tablet: 1025,
    phone: 767,
};

export const media = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
        @media (max-width: ${sizes[label]}px) {
            ${css(...args)};
        }
    `;

    return acc;
}, {});

export const breakpoint = {
    tablet: '(min-width: 768px)',
    desktop: '(min-width: 1025px)',
    lgDesktop: '(min-width: 1440px)',
};



// WEBPACK FOOTER //
// ./src/Utils/mediaQueries.js